﻿/* 
Object:         Help
Description:    Logic and events for the module Help
Used in:        Help
*/

window.help = function () {


    return {

        /**
        * Init (binding button actions)
        */
        initialize: function () {
            $("#editHelpDescription").click(function () {
                var helpTextDescription = $("#HelpDescription").data("kendoTextArea").value();
                var selectedHelpId = $("#SelectedHelpId").val();
                var selectedMenuId = $("#SelectedMenuId").val();

                $.ajax({
                    type: "POST",
                    url: appsettings.getUrl("Help/UpdateHelpText"),
                    data: { HelpId: selectedHelpId, menuId: selectedMenuId, description: helpTextDescription },
                    success: function (responseData) {
                        $("#staticNotification").kendoNotification({
                            appendTo: "#responseUpdateTextStaticNotification",
                            autoHideAfter: 3000
                        }).data("kendoNotification").show(" " + responseData.Message, "info");
                    }
                });
            });
        },

        /**
        * Init (binding button actions)
        */
        getHelp: function (menuId, label) {
            $("#LabelMenuItem").html(label);

            $.get(appsettings.getUrl("Help/GetPartialHelp?menuId=" + menuId), function (data, status) {
                
                $("#HelpDescription").data("kendoTextArea").value(data.description);
                $("#SelectedHelpId").val(data.id);
                $("#SelectedMenuId").val(data.menuId);
            });
        }
    }

}();